// React
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { MpsOrderSuccess } from '@mobilitystore/components-interface';

// Assets
import { imageLink } from '../../../../assets/img';

// CSS
import './index.scss';

const OrderSuccess = () => {
  const history = useHistory();
  const { orderId, checkoutId } = history.location.state;
  const content = useSelector((state) => state.ContentReducer?.content);

  const orderSuccessContent = content?.components?.order_success;
  const button = [
    {
      mode: 'primary',
      label: orderSuccessContent?.buttons?.[0]?.label,
      onClick: () => {
        history.push('/dashboard/place-order');
      }
    }
  ];

  const orderSuccessIcon = {
    image: `${imageLink}/${orderSuccessContent?.images?.icon?.image}`,
    alt: `${orderSuccessContent?.images?.icon?.alt}`
  };

  const orderSuccessIllustration = {
    image: `${imageLink}/${orderSuccessContent?.images?.illustration?.image}`,
    alt: `${orderSuccessContent?.images?.illustration?.alt}`
  };

  return (
    <MpsOrderSuccess
      orderSuccessIcon={orderSuccessIcon}
      title={orderSuccessContent?.title}
      description={orderSuccessContent?.description}
      orderTableTitle={orderSuccessContent?.order_table?.title}
      orderId={orderId}
      checkoutId={checkoutId}
      orderSuccessIllustration={orderSuccessIllustration}
      buttons={button}
    />
  );
};

export default OrderSuccess;
